(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["he-fuel-lp"] && !Shopify.designMode) return;
  try {
    
(() => {
  'use strict';
  const elementName = 'ohajiki-the-fuel-lp';
  if (!window.customElements || customElements.get(elementName)) return;

  class TheFuelLandingSection extends HTMLElement {
    connectedCallback() {
      if (this._setupFrame || this._initialized) return;
      this._setupFrame = requestAnimationFrame(() => {
        this._setupFrame = 0;
        if (this.isConnected) this.initialize();
      });
    }

    disconnectedCallback() {
      cancelAnimationFrame(this._setupFrame || 0);
      cancelAnimationFrame(this._scrollFrame || 0);
      this._setupFrame = 0;
      this._scrollFrame = 0;
      (this._cleanup || []).forEach(cleanup => cleanup());
      (this._observers || []).forEach(observer => observer.disconnect());
      this._cleanup = [];
      this._observers = [];
      this._initialized = false;
      this.classList.remove('the-fuel-lp--ready', 'the-fuel-lp--paused');
    }

    initialize() {
      if (this._initialized) return;
      const toggles = Array.from(this.querySelectorAll('.the-fuel-lp__motion-toggle'));
      if (!toggles.length) return;
      this._initialized = true;
      this._cleanup = [];
      this._observers = [];
      const listen = (target, type, handler, options) => {
        target.addEventListener(type, handler, options);
        this._cleanup.push(() => target.removeEventListener(type, handler, options));
      };
      const media = window.matchMedia('(prefers-reduced-motion: reduce)');
      const motionEnabled = this.dataset.motionEnabled !== 'false';
      const inEditor = this.dataset.designMode === 'true';
      // Preview the same motion in Shopify's editor as on the storefront.
      let paused = !motionEnabled || media.matches;
      const scenes = Array.from(this.querySelectorAll('[data-fuel-scene]'));
      const visibleScenes = new Set();
      const motionProperties = ['scene-y','scene-scale','visual-y','title-x','bottle-rotate','bottle-scale','perspective-angle','pointer-x'];
      const resetScenes = () => scenes.forEach(scene => motionProperties.forEach(key => scene.style.removeProperty('--the-fuel-lp-' + key)));
      this._cleanup.push(resetScenes);
      let scheduleMotion = () => {};
      const syncMotion = () => {
        this.classList.toggle('the-fuel-lp--paused', paused);
        toggles.forEach(toggle => {
          toggle.setAttribute('aria-pressed', String(paused));
          toggle.innerHTML = paused
            ? '<span aria-hidden="true">▷</span> 動きを再生'
            : '<span aria-hidden="true">Ⅱ</span> 動きを停止';
        });
        if (paused) {
          cancelAnimationFrame(this._scrollFrame || 0);
          this._scrollFrame = 0;
          resetScenes();
        } else scheduleMotion();
      };
      toggles.forEach(toggle => {
        toggle.hidden = !motionEnabled;
        listen(toggle, 'click', () => { paused = !paused; syncMotion(); });
      });
      const mediaChanged = () => { paused = !motionEnabled || media.matches; syncMotion(); };
      if (media.addEventListener) listen(media, 'change', mediaChanged);
      else if (media.addListener) {
        media.addListener(mediaChanged);
        this._cleanup.push(() => media.removeListener(mediaChanged));
      }
      syncMotion();

      const reveals = this.querySelectorAll('.the-fuel-lp__reveal');
      if ('IntersectionObserver' in window && !inEditor) {
        const revealObserver = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              entry.target.classList.add('the-fuel-lp__visible');
              revealObserver.unobserve(entry.target);
            }
          });
        }, { threshold: 0.08, rootMargin: '0px 0px -24px 0px' });
        reveals.forEach(element => revealObserver.observe(element));
        this._observers.push(revealObserver);
      } else {
        reveals.forEach(element => element.classList.add('the-fuel-lp__visible'));
      }
      this.classList.add('the-fuel-lp--ready');

      const tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      const panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
      const activate = tab => {
        tabs.forEach(item => {
          const selected = item === tab;
          item.setAttribute('aria-selected', String(selected));
          item.tabIndex = selected ? 0 : -1;
        });
        panels.forEach(panel => { panel.hidden = panel.id !== tab.getAttribute('aria-controls'); });
      };
      tabs.forEach((tab, index) => {
        listen(tab, 'click', () => activate(tab));
        listen(tab, 'keydown', event => {
          let next;
          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next !== undefined) {
            event.preventDefault();
            activate(tabs[next]);
            tabs[next].focus();
          }
        });
      });

      // Intercept only unmodified clicks on this instance's own anchors.
      this.querySelectorAll('a[href^="#"]').forEach(anchor => {
        listen(anchor, 'click', event => {
          if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          const targetId = anchor.getAttribute('href').slice(1);
          const target = Array.from(this.querySelectorAll('[id]')).find(element => element.id === targetId);
          if (!target) return;
          event.preventDefault();
          target.scrollIntoView({ behavior: paused || media.matches ? 'instant' : 'smooth', block: 'start' });
        });
      });

      const clamp = (value, min, max) => Math.max(min, Math.min(max, value));
      const updateMotion = () => {
        this._scrollFrame = 0;
        if (!this.isConnected || paused || media.matches) return;
        const viewport = window.innerHeight;
        const strength = this.getBoundingClientRect().width < 700 ? .55 : 1;
        // Read geometry together, then write only this instance's CSS variables.
        const frames = Array.from(visibleScenes, scene => ({scene, rect: scene.getBoundingClientRect()}));
        frames.forEach(({scene, rect}) => {
          const progress = clamp((viewport - rect.top) / (viewport + rect.height), 0, 1);
          const centered = (progress - .5) * 2;
          const set = (name, value) => scene.style.setProperty('--the-fuel-lp-' + name, value);
          set('scene-y', (centered * 100 * strength).toFixed(2) + 'px');
          set('scene-scale', (1.06 + progress * .07).toFixed(4));
          set('visual-y', (centered * -28 * strength).toFixed(2) + 'px');
          set('title-x', (centered * 45 * strength).toFixed(2) + 'px');
          set('perspective-angle', (centered * -4 * strength).toFixed(2) + 'deg');
          set('bottle-rotate', (centered * -22 * strength).toFixed(2) + 'deg');
          set('bottle-scale', (1.025 + progress * .055 * strength).toFixed(4));
        });
      };
      scheduleMotion = () => {
        if (!this._scrollFrame && visibleScenes.size && !paused && !media.matches) this._scrollFrame = requestAnimationFrame(updateMotion);
      };
      if ('IntersectionObserver' in window) {
        const sceneObserver = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) visibleScenes.add(entry.target);
            else visibleScenes.delete(entry.target);
            entry.target.classList.toggle('the-fuel-lp--scene-active', entry.isIntersecting);
          });
          scheduleMotion();
        }, {rootMargin: '160px 0px'});
        scenes.forEach(scene => sceneObserver.observe(scene));
        this._observers.push(sceneObserver);
      } else scenes.forEach(scene => visibleScenes.add(scene));
      listen(window, 'scroll', scheduleMotion, {passive: true});
      listen(window, 'resize', scheduleMotion, {passive: true});
      if ('ResizeObserver' in window) {
        const sizeObserver = new ResizeObserver(scheduleMotion);
        sizeObserver.observe(this);
        this._observers.push(sizeObserver);
      }
      const hero = scenes.find(scene => scene.dataset.fuelScene === 'hero');
      if (hero && window.matchMedia('(pointer: fine)').matches) {
        listen(hero, 'pointermove', event => {
          if (paused || media.matches) return;
          const rect = hero.getBoundingClientRect();
          hero.style.setProperty('--the-fuel-lp-pointer-x', ((event.clientX - rect.left - rect.width / 2) / rect.width * 28).toFixed(2) + 'px');
        }, {passive: true});
        listen(hero, 'pointerleave', () => hero.style.removeProperty('--the-fuel-lp-pointer-x'));
      }
      scheduleMotion();
    }
  }

  // Custom-element lifecycle handles theme-editor insertion, replacement and removal.
  // Shopify bundles this file's javascript tag once; multiple instances stay independent.
  customElements.define(elementName, TheFuelLandingSection);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
